export default __webpack_public_path__ + "static/media/3--240.840fe4dd.jpg";